export default __webpack_public_path__ + "static/media/electronic-icon.907daf33.svg";